import React from 'react';
import { observer } from 'mobx-react';
import { LearningPathStore } from '@seedlang/stores';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class LearningPathCreate extends React.Component {

  onCreate = name => {
    const data = {
      name,
      siteId: AppUI.site.id,
    };
    LearningPathStore.create({data}, this.props.afterCreate);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default LearningPathCreate;